import type React from 'react'
import type { SideMenuProps } from 'redesign/components/templates/SideMenu/types'
import { useSideMenuContent } from './useSideMenuContent'

const SideMenuContent: React.FC<SideMenuProps> = (props) => {
  const { PageContent } = useSideMenuContent(props)

  return PageContent
}

export default SideMenuContent
